<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">Export data Order</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="date_order">Date Order</label>
              <vc-date-picker
                mode="range"
                id="date"
                :input-props="{
                  class: 'form-control',
                  placeholder: 'Tanggal Order',
                  required: '',
                  readonly: '',
                }"
                v-model="filters.myDate"
              ></vc-date-picker>
            </div>
          </CCol>
          <CCol lg="3">
            <div class="Agent">
              <label for="filterAgent">Seller</label>
              <model-select
                class="form-control"
                id="filterAgent"
                :options="agentList"
                @input="callProvince"
                v-model="filters.agent"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
            <div class="form-group">
              <label for="province">Province</label>
              <model-select
                class="form-control"
                id="province"
                :options="provinceList"
                @input="callRegencies"
                v-model="filters.province"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
            </div>
          </CCol>
          <CCol sm="3">
            <div class="form-group">
              <label for="regency">Regency</label>
              <model-select
                class="form-control"
                id="regency"
                :options="regencyList"
                @input="callDistrict"
                v-model="filters.regency"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
            </div>
          </CCol>

          <CCol sm="3">
            <div class="form-group">
              <label for="district">District</label>
              <model-select
                class="form-control"
                id="district"
                :options="districtList"
                @input="callVillage"
                v-model="filters.district"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
            </div>
          </CCol>

          <CCol sm="3">
            <div class="form-group">
              <label for="village">Village</label>
              <model-select
                class="form-control"
                id="village"
                :options="villageList"
                v-model="filters.villages"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
            </div>
          </CCol>
        </CRow>
        <br />
        <div class="col-lg-3">
          <CButton type="button" size="sm" @click="downloadfile" color="info">
            <i class="fa fa-save"></i> Download
          </CButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "order_history",
  components: {
    loading,
    ModelSelect,
  },
  data() {
    return {
      month: [
        { value: "01", text: "January" },
        { value: "02", text: "February" },
        { value: "03", text: "March" },
        { value: "04", text: "April" },
        { value: "05", text: "May" },
        { value: "06", text: "June" },
        { value: "07", text: "July" },
        { value: "08", text: "August" },
        { value: "09", text: "September" },
        { value: "10", text: "October" },
        { value: "11", text: "November" },
        { value: "12", text: "December" },
      ],
      year: [
        { value: "2019", text: "2019" },
        { value: "2020", text: "2020" },
      ],
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      agentList: [],
      loading: false,
      filters: {
        myDate: null,
        agent: null,
        province: null,
        district: null,
        regency: null,
        villages: null,
        date_start: null,
        date_end: null,
      },
      provinceList: [],
      regencyList: [],
      districtList: [],
      villageList: [],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.loading = false;
      this.getDropdown();
    },
    getDropdown: function () {
      this.axios
        .get("/console/dropdown/export-product")
        .then((response) => {
          this.agentList = response.data.agent;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callProvince: function () {
      this.loading = true;
      this.provinceList = [];
      this.regencyList = [];
      this.districtList = [];
      this.villages = [];
      this.axios
        .get("/console/dropdown/agent_province/" + this.filters.agent)
        .then((response) => {
          this.provinceList = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callRegencies: function () {
      this.loading = true;
      this.districtList = [];
      this.axios
        .get("/console/dropdown/agent_regency/" + this.filters.agent)
        .then((response) => {
          this.regencyList = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callDistrict: function () {
      this.loading = true;
      this.villageList = [];
      this.axios
        .get("/console/dropdown/agent_district/" + this.filters.agent)
        .then((response) => {
          this.districtList = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    callVillage: function () {
      this.loading = true;
      this.axios
        .get("/console/dropdown/agent_village/" + this.filters.agent)
        .then((response) => {
          this.villageList = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadfile: function () {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if (this.filters.myDate === null) {
          alert("Tanggal Harus di pilih");
        } else {
          let start = moment(this.filters.myDate.start).format("YYYY-MM-DD");
          let end = moment(this.filters.myDate.end).format("YYYY-MM-DD");
          this.loading = true;
          this.filters.date_start = start;
          this.filters.date_end = end;
          this.axios({
            url: "console/export/order/all",
            data: this.filters,
            method: "POST",
            responseType: "blob", //before "blob"
          })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "order_history.xlsx");
              document.body.appendChild(link);
              link.click();
              for (const property in this.filters) {
                this.filters[property] = null;
                //console.log(`${property}: ${object[property]}`);
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
